export enum SmsParameters {
  CUSTOMER_NAME = 'שם-הלקוח',
  APPOINTMENT_DATE = 'תאריך-התור',
  APPOINTMENT_HOUR = 'שעת-התור',
  APPOINTMENT_SERVICE = 'שירות-נבחר',

}

export const smsParametersList = [
  SmsParameters.CUSTOMER_NAME,
  SmsParameters.APPOINTMENT_DATE,
  SmsParameters.APPOINTMENT_HOUR,
  SmsParameters.APPOINTMENT_SERVICE,
];

export const smsParametersListMapping: Record<SmsParameters, string> = {
  [SmsParameters.CUSTOMER_NAME]: 'fullName',
  [SmsParameters.APPOINTMENT_DATE]: 'date',
  [SmsParameters.APPOINTMENT_HOUR]: 'timeFrom',
  [SmsParameters.APPOINTMENT_SERVICE]: 'service',
}

